import { render, staticRenderFns } from "./FilesUploader.vue?vue&type=template&id=3d11b646&scoped=true"
import script from "./FilesUploader.vue?vue&type=script&lang=js"
export * from "./FilesUploader.vue?vue&type=script&lang=js"
import style0 from "./FilesUploader.vue?vue&type=style&index=0&id=3d11b646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d11b646",
  null
  
)

export default component.exports